// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__MIb7H","large":"styles_large__conGa"};